// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    suggestionMobileStyle: 'style2', // style1, style2
  }
};

(function() {

  BoostPFS.inject(this); // Add this
  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
    if (jQ(searchBoxId).closest('.search_container').length > 0) {
      this.setSuggestionWidth(searchBoxId, 400);
    }
  };
  
  /* Fix search issue on mobile */
  InstantSearch.prototype.init = function() {
    var inputElements = jQ('input[name="' + Settings.getSettingValue('search.termKey') + '"]:not([data-disable-instant-search])');
    inputElements.each((index, inputElement) => {

      if (jQ(inputElement).attr('id') == 'q' && Utils.isMobile()) {
        var id = jQ(inputElement).attr('id');
      } else {
        var id = 'boost-pfs-search-box-' + index;
      }
      var searchBox = new SearchInput(id, jQ(inputElement));
      this.addComponent(searchBox);
    });
    // Build search input for mobile
    if (Utils.isMobile()) {
      // Clear cache when going back from another page
      window.onpageshow = (event) => {
        if (event.persisted) {
          window.location.reload();
        }
      }
      // Build Suggestion mobile on top
      if (Settings.getSettingValue('search.suggestionMobileStyle') !== InstantSearchEnum.Mobile.SuggestionType.STYLE_2) {
        var instantSearchMobile = InstantSearchStyle.instantSearchMobile();
        this.addComponent(instantSearchMobile);
      }
    }
  };

  InstantSearchMobile.prototype.afterCloseInstantSearchMobile = function (isClose) {
    jQ('.close-search').click();
  }

  /**
	 * Build the product price and replace with the brackets in raw html template
	 */
	InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
        var data = this.data;
		// If the multi-currency feature is enabled, update the product price
		this.prepareSuggestionProductPriceData();
     	// First variant
      	var firstVariant = this.data.variants[0];
        for(var i = 0; i < this.data.variants.length; i++){
          if(this.data.variants[i].available){
          	firstVariant = this.data.variants[i];
            break;
          }
        }
		// Check on sale
		// var onSale = firstVariant.compare_at_price > firstVariant.price;
        var onSale = data.compare_at_price_min > data.price_min;
      var ifEqual = firstVariant.compare_at_price == firstVariant.price;
		// Format price
 
		var price = window.Shopify.formatMoney(parseFloat(firstVariant.price) * (typeof firstVariant.price === 'string' ? 100 : 1), 'CHF {{ amount_with_apostrophe_separator }}');
		var compareAtPrice = '';
        if (!(data.product_type == 'Distillati' || data.product_type == 'Liquori' || data.product_type == 'Dolci' || data.product_type == 'Idee Regalo')) {
          if (firstVariant && firstVariant.compare_at_price) {
              compareAtPrice = ifEqual ? "" : window.Shopify.formatMoney(parseFloat(firstVariant.compare_at_price) * (typeof firstVariant.price === 'string' ? 100 : 1), 'CHF {{ amount_with_apostrophe_separator }}') ;
              if (Settings.getSettingValue('search.removePriceDecimal')) {
                  price = Utils.removeDecimal(price);
                  compareAtPrice = Utils.removeDecimal(compareAtPrice);
              }
          }
        }
		
		// Build Price
		var result = '';
		if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
			if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
			} else {
                if(parseFloat(firstVariant.compare_at_price) > parseFloat(firstVariant.price)){
                    result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
                }else{
    				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
                }
			}
		}

      
		return result.replace(/{{regularPrice}}/g, price).replace(/{{compareAtPrice}}/g, compareAtPrice);
			
			
	}

	InstantSearchResultItemProduct.prototype.getTemplate = function(tempType) {
		switch (tempType) {
			case InstantSearchResultItemProduct.tempType.IMAGE:
				return `
					<div class="{{class.searchSuggestion}}-left">
						{{saleLabel}}
						<img src="{{imageUrl}}" alt="{{escapedTitle}}">
					</div>
				`.trim();
			case InstantSearchResultItemProduct.tempType.SKU:
				return `
					<p class="{{class.searchSuggestion}}-product-sku">SKU: {{sku}}</p>
				`.trim();
			case InstantSearchResultItemProduct.tempType.VENDOR:
				return `
					<p class="{{class.searchSuggestion}}-product-vendor">{{vendor}}</p>
				`.trim();
			case InstantSearchResultItemProduct.tempType.PRICE:
				return `
					<p class="{{class.searchSuggestion}}-product-price">
						<span class="{{class.searchSuggestion}}-product-regular-price">{{regularPrice}}</span>
					</p>
				`.trim();
			case InstantSearchResultItemProduct.tempType.PRICE_SALE:
				return `
					<p class="{{class.searchSuggestion}}-product-price">
						<s>{{compareAtPrice}}</s>
						<span class="{{class.searchSuggestion}}-product-sale-price">{{regularPrice}}</span>
					</p>
				`.trim();
			default:
				return `
					<li class="{{class.searchSuggestionItem}} {{class.searchSuggestionItem}}-product {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedTitle}}" data-id="{{id}}">
						<a href="{{url}}" {{newTabAttribute}}>
							{{itemProductImage}}
							<div class="{{class.searchSuggestion}}-right">
								<p class="{{class.searchSuggestion}}-product-title">{{title}}</p>
								{{itemProductSku}}
								{{itemProductVendor}}
								{{itemProductPrice}}
							</div>
						</a>
					</li>
				`.trim();
		}
	}

	InstantSearchResultItemProduct.prototype.compileTemplate = function() {
		if (this.isShow) {
			var searchTerm = Utils.escape(Globals.currentTerm);
			// Product image
			var imageHTML = '';
			if (BoostPFS.Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
				imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
				imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
			}
			// Product title
			var productTitle = this.customizeProductTitle();
			productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
			// SKU
			var skuHTML = '';
			if (BoostPFS.Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
				skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
				skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
			}
			// Vendor
			var vendorHTML = '';
			if (BoostPFS.Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
				vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
				vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
			}
			// Price
			var priceHTML = this.compileSuggestionProductPrice();
			// Open the result item in new tab when selected
			var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';
			var itemSaleLabel = '';
			var data = this.data;
            var boostFirstVariant = data.variants[0];
            for(var i = 0; i < data.variants.length; i++){
              if(data.variants[i].available){
                boostFirstVariant = data.variants[i];
                break;
              }
            }
console.log('test',boostFirstVariant);
            var onSale = data.compare_at_price_min > data.price_min;
            if (onSale) {
              if (data.product_type == 'Distillati' || data.product_type == 'Liquori' || data.product_type == 'Dolci' || data.product_type == 'Idee Regalo' ) {
                itemSaleLabel = '<div class="price-ui-badge price-ui-badge--new">' +
                                  '<div class="price-ui-badge__sticker price-ui-badge__sticker--new">' +
                                    '<span class="price-ui-badge__sticker-text price-ui-badge__sticker-text--new">HIT</span>' +
                                  '</div>' +
                                '</div>'
              } else {
                //var percSale = Math.ceil((data.compare_at_price_max - data.price_max) / data.compare_at_price_max * 100);
                var percSale = Math.round(((boostFirstVariant.compare_at_price - boostFirstVariant.price) * 100) / boostFirstVariant.compare_at_price);
                itemSaleLabel = '<div class="price-ui-badge price-ui-badge--new">' +
                                  '<div class="price-ui-badge__sticker price-ui-badge__sticker--new">' +
                                    '<span class="price-ui-badge__sticker-text price-ui-badge__sticker-text--new">'+
                                        percSale
                                    +'%</span>' +
                                  '</div>' +
                                '</div>'
              }
            }else{
              if(parseFloat(boostFirstVariant.compare_at_price) > parseFloat(boostFirstVariant.price)){
                var percSale = Math.round(((boostFirstVariant.compare_at_price - boostFirstVariant.price) * 100) / boostFirstVariant.compare_at_price);
                itemSaleLabel = '<div class="price-ui-badge price-ui-badge--new">' +
                                  '<div class="price-ui-badge__sticker price-ui-badge__sticker--new">' +
                                    '<span class="price-ui-badge__sticker-text price-ui-badge__sticker-text--new">'+
                                        percSale
                                    +'%</span>' +
                                  '</div>' +
                                '</div>'
              }
            }

			return this.getTemplate()
				.replace(/{{id}}/g, this.id)
				.replace(/{{escapedBlockType}}/g, Utils.escape(this.parent.type))
				.replace(/{{url}}/g, this.url)
				.replace(/{{newTabAttribute}}/g, newTabAttr)
				.replace(/{{itemProductImage}}/g, imageHTML)
				.replace(/{{title}}/g, productTitle)
				.replace(/{{escapedTitle}}/g, Utils.escape(productTitle))
				.replace(/{{itemProductSku}}/g, skuHTML)
				.replace(/{{itemProductVendor}}/g, vendorHTML)
				.replace(/{{itemProductPrice}}/, priceHTML)
				.replace(/{{saleLabel}}/g, itemSaleLabel)
				.replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
				.replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
				.replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem);
		} else {
			return '';
		}
	}

  // Start boost - 153373
  // Fix issue when scrolling
  window.addEventListener('scroll', function() {
    if(!Utils.isMobile()) {
    jQ('.boost-pfs-search-suggestion-wrapper').hide()
    }
  })

  // Keep it Open until clicking outside
  var onCloseAutocomplete = SearchInput.prototype.onCloseAutocomplete;
  
  SearchInput.prototype.onCloseAutocomplete = function() {
    if (!Utils.isMobile()) {
      onCloseAutocomplete.call(this);
      return;
    }
    
    this.instantSearchResult.$instantSearchResult.show();
    var container = this.instantSearchResult.$wrapper;
    var self = this;
    
    jQ(document).on('click', function(e) {
      if (!container.is(e.target) && container.has(e.target).length === 0 && 
          !self.$element.is(e.target) && self.$element.has(e.target).length === 0) {
          self.instantSearchResult.$instantSearchResult.siblings().hide();
          self.instantSearchResult.$wrapper.removeClass(Class.searchSuggestionOpen);
      }
      
    });
  }

  // Bind submit/click event to the search icon
  SearchInput.prototype.bindEvents = function() {
    if (jQ('search__button').length) {
        jQ('search__button').on('click', this._onSubmit.bind(this));
    }
  }
  // End boost - 153373
})();